import { EntitlementService } from './entitlement.service';
import { NAVIGATION_ITEMS } from '../navigation-items';
import { Injectable, Output, EventEmitter } from '@angular/core';
import { NavItem } from '../navItem';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  @Output() refreshNavigationEvent: EventEmitter<boolean> = new EventEmitter();
  navItems: NavItem[] = [];

  constructor(
    private entitlementService: EntitlementService
  ) {
    this.setNavigationItems(NAVIGATION_ITEMS);
  }

  setNavigationItems(navItems: NavItem[]) {
    this.navItems = navItems;
  }

  getEntitledNavigationItems() {
    return this.navItems.filter(item => {
      return (
        item.route !== null &&
        (this.entitlementService.hasEntitlement(item.entitlement) ||
          item.entitlement === undefined ||
          item.entitlement === null)
      );
    });
  }

  getNavItemById(id: number): NavItem {
    if (this.navItems.length > 0) {
      this.navItems.forEach(navItem => {
        if (navItem.id === id) {
          return navItem;
        }
      });
    }
    return null;
  }

  getNavItemByRoute(route: string): NavItem {
    let returnItem: NavItem = null;
    if (this.navItems.length > 0) {
      this.navItems.forEach(navItem => {
        if (route === navItem.route) {
          returnItem = navItem;
        }
      });
    }
    return returnItem;
  }

}
